module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Join-2-5a4779b061559808a5c842f031c3900cd2ec2d486e0f9ccb37e0f10d878dbde0.svg";